/* tslint:disable */
/* eslint-disable */
/**
 * Gestionale.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ChiusuraCompensoUpdateDTO
 */
export interface ChiusuraCompensoUpdateDTO {
    /**
     * 
     * @type {number}
     * @memberof ChiusuraCompensoUpdateDTO
     */
    sequenza?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ChiusuraCompensoUpdateDTO
     */
    descrizione?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ChiusuraCompensoUpdateDTO
     */
    importo?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ChiusuraCompensoUpdateDTO
     */
    bold?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ChiusuraCompensoUpdateDTO
     */
    color?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ChiusuraCompensoUpdateDTO
     */
    esclusoDaTotale?: boolean;
}

/**
 * Check if a given object implements the ChiusuraCompensoUpdateDTO interface.
 */
export function instanceOfChiusuraCompensoUpdateDTO(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ChiusuraCompensoUpdateDTOFromJSON(json: any): ChiusuraCompensoUpdateDTO {
    return ChiusuraCompensoUpdateDTOFromJSONTyped(json, false);
}

export function ChiusuraCompensoUpdateDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChiusuraCompensoUpdateDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'sequenza': !exists(json, 'sequenza') ? undefined : json['sequenza'],
        'descrizione': !exists(json, 'descrizione') ? undefined : json['descrizione'],
        'importo': !exists(json, 'importo') ? undefined : json['importo'],
        'bold': !exists(json, 'bold') ? undefined : json['bold'],
        'color': !exists(json, 'color') ? undefined : json['color'],
        'esclusoDaTotale': !exists(json, 'esclusoDaTotale') ? undefined : json['esclusoDaTotale'],
    };
}

export function ChiusuraCompensoUpdateDTOToJSON(value?: ChiusuraCompensoUpdateDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'sequenza': value.sequenza,
        'descrizione': value.descrizione,
        'importo': value.importo,
        'bold': value.bold,
        'color': value.color,
        'esclusoDaTotale': value.esclusoDaTotale,
    };
}

